import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CentimetersButton, InchesButton } from './buttons';
import { Regions, MeasurementSystem, CountryToRegionMap } from './constants';
import Dropdown from './dropdown';
import Table from './table';
import Title from './title';

const { country } = window.inlineGlobalConfig.locale;
const initialRegion = Regions.find(i => i.id === CountryToRegionMap[country]);

const InteractiveSizeGuide = ({ silhouette, gender, handleClose }) => {
  const [measurementSystem, setMeasurementSystem] = useState(MeasurementSystem.imperial);
  const [selectedRegion, setSelectedRegion] = useState(initialRegion);
  const [isOpen, setIsOpen] = useState(false);
  const onDropdownClick = () => {
    setIsOpen(s => !s);
  };

  const dropdownListClick = region => {
    setSelectedRegion(region);
    setIsOpen(false);
  };

  return (
    <div className="interactive-size-guide">
      <Dropdown
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        selectedItem={selectedRegion}
        dropdownList={Regions}
        onDropdownClick={onDropdownClick}
        onItemClick={dropdownListClick}
      />
      <Title
        isOpen={isOpen}
        gender={gender}
        product={silhouette}
        region={selectedRegion}
        measurementSystem={measurementSystem}
      />
      <div className="interactive-size-guide__btns">
        <InchesButton
          isDisabled={isOpen}
          isSelected={measurementSystem.id === MeasurementSystem.imperial.id}
          onClick={() => setMeasurementSystem(MeasurementSystem.imperial)}
        />
        <CentimetersButton
          isDisabled={isOpen}
          isSelected={measurementSystem.id === MeasurementSystem.metric.id}
          onClick={() => setMeasurementSystem(MeasurementSystem.metric)}
        />
      </div>
      <Table
        silhouette={silhouette}
        showEmptyTable={isOpen}
        selectedRegion={selectedRegion}
        measurementSystem={measurementSystem}
      />
      {handleClose && (
        <button type="button" className="interactive-size-guide__done" onClick={handleClose}>
          <FormattedMessage id="interactiveSizeGuide.done" description="DONE" />
        </button>
      )}
    </div>
  );
};

export default InteractiveSizeGuide;
